import { idtype } from "querypieces"

export default `
  ...on contentBlocks_colorTile_BlockType {
    ${idtype}
    name: pageTitle
    color: backgroundColor
  }
`
